import { render, staticRenderFns } from "./newZx.vue?vue&type=template&id=4a402fe0&scoped=true&"
import script from "./newZx.vue?vue&type=script&lang=js&"
export * from "./newZx.vue?vue&type=script&lang=js&"
import style0 from "./newZx.vue?vue&type=style&index=0&id=4a402fe0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a402fe0",
  null
  
)

export default component.exports